<template>
  <Carousel v-bind="settings" class="w-auto">
    <Slide v-for="(item, index) in items" :key="index" class="items-start">
      <div class="flex flex-col gap-4">
        <div v-for="(n, i) in item" :key="i">
          <div class="flex flex-col items-center gap-3 cursor-pointer" @click="clickAction(n)">
            <NuxtImg :src="n.url" quality="90" loading="lazy" @error="setDefaultImage"
              :class="{ 'h-24 w-24 rounded-full': isCircle, 'h-20 w-20 rounded-full': isMiniCircle, 'h-20 w-20 rounded-md': isSquare }"  alt="Category image" title="Category image"/>
            <h5 class="line-clamp-2 h-12 px-2 breaks-all text-center text-sm">{{ n.title }}</h5>
          </div>
        </div>
      </div>
    </Slide>
  </Carousel>
</template>

<script setup>
const { gtag } = useGtag();
const { isMobile } = useDevice()
const runtimeConfig = useRuntimeConfig();
const props = defineProps(['items', 'layout']);
const emit = defineEmits(['selected']);

const isCircle = props.layout === 'circle';
const isMiniCircle = props.layout === 'minicircle';
const isSquare = props.layout === 'square';

const itemsToShow = computed(() => {
  if (isCircle) {
    return isMobile ? 3.4 : 8.8;
  } else if (isMiniCircle) {
    return isMobile ? 3.5 : 8.4;
  }
  return isMobile ? 3.2 : 7.8;
});

const settings = {
  itemsToShow: itemsToShow.value,
  snapAlign: 'start',
  preventExcessiveDragging: true
};

const setDefaultImage = (event) => {
  event.imageSrc = runtimeConfig.public.defaultImage;
}

const clickAction = async (item) => {
  const auth = useAuth();
  gtag('event', 'cta_event', {
    cta_name: 'sub category',
    sub_category_name: item.title,
    user_name: auth && auth.access_token ? auth.user.first_name : null,
    user_phone: auth && auth.access_token ? auth.user.phone : null,
    user_email: auth && auth.access_token ? auth.user.email : null
  });
  await useBannerAction({ action: { type: 'href', target: item.href } });
}

</script>
